var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContentIcon = function SvgContentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 13.3V35.7C36.75 35.9785 36.6394 36.2455 36.4425 36.4425C36.2455 36.6394 35.9785 36.75 35.7 36.75H13.3C13.0215 36.75 12.7545 36.6394 12.5575 36.4425C12.3606 36.2455 12.25 35.9785 12.25 35.7V13.3C12.25 13.0215 12.3606 12.7545 12.5575 12.5575C12.7545 12.3606 13.0215 12.25 13.3 12.25H35.7C35.9785 12.25 36.2455 12.3606 36.4425 12.5575C36.6394 12.7545 36.75 13.0215 36.75 13.3Z",
    stroke: "#B472DD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 7H8.05C7.77152 7 7.50445 7.11062 7.30754 7.30754C7.11062 7.50445 7 7.77152 7 8.05V31.5M12.25 29.4L21.777 26.25L36.75 31.5M28.875 22.75C28.1788 22.75 27.5111 22.4734 27.0188 21.9812C26.5266 21.4889 26.25 20.8212 26.25 20.125C26.25 19.4288 26.5266 18.7611 27.0188 18.2688C27.5111 17.7766 28.1788 17.5 28.875 17.5C29.5712 17.5 30.2389 17.7766 30.7312 18.2688C31.2234 18.7611 31.5 19.4288 31.5 20.125C31.5 20.8212 31.2234 21.4889 30.7312 21.9812C30.2389 22.4734 29.5712 22.75 28.875 22.75Z",
    stroke: "#B472DD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgContentIcon;